import React from 'react';
import { Element } from 'react-scroll';

export default ({ name, children }) => (
  <Element name={name} style={{ position: 'relative', flex: '1 1 auto' }}>
    {children}
  </Element>
);
